import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
// import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';

// import Section from 'components/structure/Section';
import Block from './components/structure/Block/Block.js';
import Carousel from './components/Carousel/Carousel.js';

const modules = [
{
  intlKey: '1',
  name: ' ',
  txt: 'Onboarding institucional e técnico;',
},
{
  intlKey: '2',
  name: ' ',
  txt: 'Plano de desenvolvimento',
},
{
  intlKey: '3',
  name: ' ',
  txt: 'Feedback trimestral.',
},
{
  intlKey: '4',
  name: ' ',
  txt: 'Encontros com a comunidade de estágio do Nubank',
}
];

class SectionBootcampModules extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = step => {
    this.setState(() => ({
      currentStep: step,
    }));
  };

  render() {
    const { currentStep } = this.state;

    return (
      <Box
        tag="section"
        // paddingBottom={{ xs: '12x', md: '10x' }}
        alignItems= 'left'
          >

          <Box
            paddingHorizontal={{ xs: '1x', md: '12x', lg: 56 }}
            // marginTop={{ xs: '8x', md: '12x', lg: '20x' }}
            display={{ lg: 'grid' }}
            gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
            gridColumnGap={{ lg: '8x' }}
            >
            <Box
              gridColumn={{ lg: '2 / 12' }}
              maxWidth={{ md: '700px', lg: '700px' }}
              marginHorizontal={{ md: 'auto' }}
              justify='left'
              alignItems='left'
              >
              <Typography
                variant="heading3"
                strong
                // marginBottom={{ xs: '6x' }}
                // marginHorizontal={{ md: 'auto' }}
                // maxWidth={{ xs: '12ch', lg: 'none' }}
                textAlign='left'
                gutterBottom={1.5}
                >
                Trilha de desenvolvimento:
              </Typography>

              <Block
              // paddingBottom="10x"
               blockWidth="100%" textAlign="center" justifyContent="center">

              <Carousel
                textAlign= 'center'
                currentStep={currentStep}
                onStepChanged={this.handleChangeCarouselStep}
                // textAlign="center" justifyContent="center"
                >
                {modules.map(module => (
                  <div key={module.intlKey}>
                    <Typography 
                      variant="heading4" strong 
                      color="primary" 
                      textAlign="center" 
                      gutterBottom={1}
                      justifyContent="center">
                      {module.name}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      // tag="p"
                      // gutterBottom={1}
                      textAlign="center" justifyContent="center"
                      >
                      {module.txt}
                      {/* <FormattedMessage id={`${quote.intlKey}`}> */}
                      {/*   {/* {quote.txt} */} 
                      {/*   {${quote.txt} => `"${txt}"`} */}
                      {/* </FormattedMessage> */}
                    </Typography>
                    
                    {/* <Typography variant="paragraph2"  textAlign="center" justifyContent="center"> */}
                    {/*   {quote.position} */}
                    {/* </Typography> */}

                    </div>
                    ))}
              </Carousel>

              </Block>
            </Box>
          </Box>
          </Box>

          );
  }
}

export default SectionBootcampModules;
